const theme = {
  colors: {
    mainColor: '#0b5a5c',
    background: '#EBF1F4',
    white: '#ffffff',
    gray: '#404040',
    lightGray: '#606060',
    red: '#B83A30',
    blue: '#073469',
    hoverBlue: '#0C52A8',
    hover: '#307070',
    hoverRed: '#CF4E2B',
    desactivated: '#647776',
    accent: '#31F5F2',
    emphasis: '#22A8A6',
    header: '#f5f5f5',
    text: '#000000',
    pending: '#DEBE21',
    rejected: '#F57620',
    blocked: '#B83A30',
    active: '#18A3A8',
  },
  border: {
    max: '1rem',
    default: '0.5rem',
    min: '0.25rem',
  },
  padding: {
    max: '1rem',
    default: '0.5rem',
    min: '0.25rem',
  },
  margin: {
    max: '1rem',
    default: '0.5rem',
    min: '0.25rem',
  },
  fontSize: {
    max: '1.5rem',
    big: '1.25rem',
    medium: '1rem',
    small: '0.75rem',
    min: '0.5rem',
  },
  shadow: {
    default: '0 0.25rem 0.5rem 0 rgba(0, 0, 0, 0.1)',
  },
  transitionDuration: {
    default: '250ms',
  },
  mediaQuery: {
    mobileS: '320px',
    mobileM: '375px',
    mobileL: '425px',
    notebookSm: '1024px',
    notebook: '1366px',
    desktop: '1920px',
  },
};

export default theme;
